import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { ParserService } from 'src/app/component/broker-parser/planner-service/parser-service';
import { BrokerDropdownService } from 'src/app/component/shared/broker-dropdown/broker-dropdown.service';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { sweetAlert } from 'src/app/utils/swal';
import { ReportService } from '../../../reports/reports-service/report.service';

@Component({
  selector: 'app-add-edi-report',
  templateUrl: './add-edi-report.component.html',
  styleUrls: ['./add-edi-report.component.css']
})
export class AddEdiReportComponent implements OnInit {
@ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  selectedFile = null;
  submitted = false;
  invalidFileType = false;
  isTripsLoading = false;
  todayDate;

  constructor(
    private fb: FormBuilder,
    private sharedDataService: SharedDataService,
    private reportService : ReportService,
    private router: Router) { }

  ngOnInit() {


    this.getUser();

  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.todayDate = moment.tz(data.timeZone).startOf('day').toISOString();
        }
      });
  }


  submitFile() {
    this.submitted = true;
    if(this.selectedFile === null){
      return;
    }
    this.reportService.addEdiReport(this.selectedFile).subscribe(data => {
        if (data) {
          this.router.navigateByUrl("reports/edireports");
        }
      })


  }

    readURL(event): void {
    console.log(event)
    if (event.target && event.target.files && event.target.files[0]) {
      this.selectedFile = event.target.files[0];
    console.log(this.selectedFile)

    }
  }


  onDateChange(event) {
    this.todayDate = event;
  }


  ngOnDestroy(): void { }
}

